<template>
  <div class="projectFormLess" v-if="isComponentsShow">
    <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel">
        <img style="width:17px" src="../../assets/image/icon_gs@2x.png" alt />
        <span>公司名称</span>
      </div>
      <div class="rightInput">
        <el-input
          v-model="addFormData.project_full_name"
          :disabled="!isSubmit"
        ></el-input>
      </div>
    </div>
    <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel">
        <img style="width:17px" src="../../assets/image/icon_gs@2x.png" alt />
        <span>项目名称</span>
      </div>
      <div class="rightInput">
        <el-input
          v-model="addFormData.project_detail_name"
          :disabled="!isSubmit"
        ></el-input>
      </div>
    </div>
    <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel">
        <img style="width:17px" src="../../assets/image/icon_gs@2x.png" alt />
        <span>项目全称</span>
      </div>
      <div class="rightInput">
        <!-- 项目全称由“公司名称 + 项目名称”自动拼接，只读不可编辑 -->
        <el-input
          v-model="addFormData.company_name"
          disabled
          placeholder="由公司名称 + 项目名称自动生成"
        ></el-input>
      </div>
    </div>

    <div
      v-if="isSubmit"
      style="font-size:12px;margin-left:150px;color: rgb(245, 95, 95);margin-bottom:10px;margin-top:0px"
    >*请先搜索确认该项目是否已立项，避免重复</div>

    <div class="oneRow" style="margin-bottom:35px;width:75%;min-width:650px" v-if="isSubmit">
      <div class="leftLabel">
        <img style="width:17px" src="../../assets/image/icon_zhongd@2x.png" alt />
        <span>项目检索</span>
      </div>
      <el-select
        v-model="project_id"
        style="width:calc(100% - 150px);overflow:hidden"
        :filter-method="searchProjectList"
        filterable
        remote
        :multiple="true"
        @change="handleProjectSelectChange1"
        placeholder="项目名称"
      >
        <el-option
          v-for="(item, num) in projectList"
          :key="item.project_id"
          style="max-width:40vw"
          :label="item.project_show"
          :value="item.project_id"
        ></el-option>
      </el-select>
    </div>

    <div class="oneRow" style="margin-bottom:20px">
      <div class="leftLabel">
        <img style="width:16px" src="../../assets/image/icon_bh@2x.png" alt />
        <span>项目年份</span>
      </div>
      <div class="rightInput">
        <!-- <el-date-picker
          v-model="project_years"
          :disabled="!isSubmit"
          type="year"
          format="yyyy"
          value-format="yyyy"
          @change="yearChange"
        /> -->
        <!-- :disabled="draftDisable" -->
        <el-date-picker
            
            v-model="project_years"
            type="date"
            style="width:100%"
            placeholder="项目年份"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
      </div>
    </div>

    <div class="oneRow" style="margin-bottom:20px" v-if="addFormData.member">
      <div class="leftLabel">
        <img style="width:16px" src="../../assets/image/icon_zhmc@2x.png" alt />
        <span>项目登记人</span>
      </div>
      <div class="rightInput">
        <span class="isNotSubmitSpan">{{ addFormData.member.nickname }}</span>
      </div>
    </div>

    <div class="oneRow" style="margin-bottom:20px" v-if="addFormData.project_code">
      <div class="leftLabel">
        <img style="width:16px" src="../../assets/image/icon_bh@2x.png" alt />
        <span>项目编号</span>
      </div>
      <div class="rightInput">
        <span class="isNotSubmitSpan">{{ addFormData.project_code }}</span>
      </div>
    </div>

    <div class="oneRow" style="margin-bottom:30px" v-if="addFormData.contract_code">
      <div class="leftLabel">
        <img style="width:16px" src="../../assets/image/icon_bh@2x.png" alt />
        <span>合同编号</span>
      </div>
      <div class="rightInput">
        <span v-if="addFormData.contract_code == '缺少合同登记'" class="isNotSubmitSpan">
          <span style="margin-right:10px" class="isNotSubmitSpan">{{ addFormData.contract_code }}</span>
          <span class="isNotSubmitSpan pointisNotSubmitSpan" @click="goContract">(点击去合同登记)</span>
        </span>
        <span v-else class="isNotSubmitSpan">{{ addFormData.contract_code }}</span>
      </div>
    </div>

    <div class="oneRow" style="margin-bottom:30px" v-if="addFormData.contract_code">
      <div class="leftLabel"></div>
      <div class="rightInput" style="display:flex;align-items:center">
        <div style="color:rgb(245, 95, 95);font-size:12px;">
          *项目结算前需要完成合同登记，没有合同请填写说明表
        </div>
        <a style="font-size:14px;" href="http://control.sxpz.vip/Template/未拿回合同说明表.doc">
          未拿回合同说明表.doc
        </a>
      </div>
    </div>

    <div class="towRow" style="margin-bottom:35px">
      <div class="towRowBox">
        <div class="leftLabel">
          <img style="width:16px" src="../../assets/image/icon_zhmc@2x.png" alt />
          <span>内部业务人员</span>
        </div>
        <div class="rightInput">
          <one-selected
            v-if="isSubmit"
            :selectedId="addFormData.inside_salesman_id"
            :selectedName="addFormData.inside_salesman.nickname"
            style="width:100%"
            @my-one-change="transferChange"
          ></one-selected>
          <span v-else class="isNotSubmitSpan">{{ addFormData.inside_salesman.nickname }}</span>
        </div>
      </div>
      <div class="towRowBox">
        <div class="leftLabel leftLabel2">
          <img style="width:16px" src="../../assets/image/icon_zhmc@2x.png" alt />
          <span>外部业务人员</span>
        </div>
        <div class="rightInput">
          <el-input
            v-model="addFormData.external_salesman"
            :disabled="!isSubmit"
            :placeholder="isSubmit ? '输入姓名' : ''"
          ></el-input>
        </div>
      </div>
    </div>

    <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel relatedPersonnelLabel" style="width: 240px">
        <img style="width:16px" src="../../assets/image/icon_zhmc@2x.png" alt />
        <span style="white-space: nowrap">其他参与的业务人员</span>
      </div>
      <div class="rightInput" style="width: calc(100% - 240px)">
        <select-transfer
          :disabled="!isSubmit"
          :selectedId="relatedPersonnelIds"
          style="width:100%"
          @my-transfer-change="handleRelatedPersonnelChange"
        ></select-transfer>
      </div>
    </div>

    <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel">
        <img style="width:16px" src="../../assets/image/icon_xmlx@2x.png" alt />
        <span>仅申请项目编号</span>
      </div>
      <div class="rightInput">
        <el-radio-group v-model="addFormData.demand_type">
          <el-radio :disabled="!isSubmit" :label="'2'">是</el-radio>
          <el-radio :disabled="!isSubmit" :label="'1'">否</el-radio>
        </el-radio-group>
      </div>
    </div>

    <div class="oneRow" style="margin-bottom:15px">
      <div class="leftLabel">
        <img style="width:16px" src="../../assets/image/icon_zy@2x.png" alt />
        <span>负责部门</span>
      </div>
      <div class="rightInput">
        <el-radio-group v-model="addFormData.department_id">
          <el-radio
            v-for="item in classList"
            :key="item.department_id"
            :disabled="!isSubmit"
            :label="item.department_id"
          >{{ item.department_name }}</el-radio>
        </el-radio-group>
      </div>
    </div>

    <div class="oneRow" style="margin-bottom:15px">
      <div class="leftLabel"></div>
      <div class="rightInput">
        <div style="color:rgb(245, 95, 95);margin-bottom:15px;font-size:12px">
          *请正确选择，决定流程走向，非常重要
        </div>
      </div>
    </div>

    <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel">
        <img style="width:16px" src="../../assets/image/icon_xmlx@2x.png" alt />
        <span>项目类型</span>
      </div>
      <div class="rightInput">
        <el-radio-group v-model="addFormData.project_type_id">
          <el-radio
            v-for="item in projectTypeList"
            :key="item.project_type_id"
            :disabled="!isSubmit"
            :label="item.project_type_id"
          >{{ item.project_type_name }}</el-radio>
        </el-radio-group>
      </div>
    </div>

    <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel">
        <img style="width:16px" src="../../assets/image/icon_xklx@2x.png" alt />
        <span>许可类型</span>
      </div>
      <div class="rightInput">
        <el-radio-group
          v-model="addFormData.permit_type"
          :disabled="!isSubmit"
          @change="selectPermitChange"
        >
          <el-radio :label="'1'">一般类</el-radio>
          <el-radio :label="'2'">许可类</el-radio>
        </el-radio-group>
      </div>
    </div>

    <div class="oneRow" style="margin-bottom:35px" v-if="addFormData.permit_type == '2'">
      <div class="leftLabel">
        <img style="width:16px" src="../../assets/image/icon_pingjialx@2x.png" alt />
        <span>行业类型</span>
      </div>
      <div class="rightInput">
        <el-radio-group v-model="addFormData.permit_type_sub" :disabled="!isSubmit">
          <el-radio :label="'1'">危化</el-radio>
          <el-radio :label="'2'">冶金</el-radio>
          <el-radio :label="'3'">矿山</el-radio>
        </el-radio-group>
      </div>
    </div>

    <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel upLoadLabel" style="padding-top:0">
        <img style="width:16px;margin-top:12px" src="../../assets/image/icon_pingjialx@2x.png" alt />
        <span style="margin-top:8px">评价类型</span>
      </div>
      <div class="rightInput">
        <!-- 评价类型：is_department=0 的节点可多选，其余当目录 -->
        <evaluation-type-select
          :options="projectPjList"
          :selected-id="pteTypeIds"
          :disabled="!isSubmit"
          @change="handlePteTypeChange"
        ></evaluation-type-select>
      </div>
    </div>

    <div class="towRow" style="margin-bottom:35px">
      <div class="towRowBox">
        <div class="leftLabel">
          <img style="width:17px" src="../../assets/image/icon_lxr@2x.png" alt />
          <span>项目联系人</span>
        </div>
        <div class="rightInput">
          <el-input
            v-model="addFormData.contacts"
            :disabled="!isSubmit"
            :placeholder="isSubmit ? '输入姓名' : ''"
          ></el-input>
        </div>
      </div>
      <div class="towRowBox">
        <div class="leftLabel leftLabel2">
          <img style="width:13px" src="../../assets/image/icon_sjzh@2x.png" alt />
          <span>联系电话</span>
        </div>
        <div class="rightInput">
          <el-input
            v-model="addFormData.contact_number"
            :disabled="!isSubmit"
            :placeholder="isSubmit ? '输入电话' : ''"
          ></el-input>
        </div>
      </div>
    </div>

    <div v-if="vccode == '1'">
      <div class="oneRow" style="margin-bottom:35px">
        <div class="leftLabel">
          <img style="width:16px" src="../../assets/image/icon_zhongd@2x.png" alt />
          <span>是否参与投标</span>
        </div>
        <div class="rightInput">
          <el-radio-group v-model="addFormData.is_bid" :disabled="!isSubmit">
            <el-radio :label="'1'">是</el-radio>
            <el-radio :label="'0'">否</el-radio>
          </el-radio-group>
        </div>
      </div>

      <div class="oneRow" style="margin-bottom:35px" v-if="addFormData.is_bid == '1'">
        <div class="leftLabel">
          <img style="width:16px" src="../../assets/image/icon_jine@2x.png" alt />
          <span>投标金额</span>
        </div>
        <div class="rightInput">
          <div class="rightInput">
            <el-input
              v-model="addFormData.bid_money"
              placeholder="请输入投标金额"
              :disabled="!isSubmit"
              type="number"
            ></el-input>
          </div>
        </div>
      </div>

      <div class="oneRow" style="margin-bottom:35px">
        <div class="leftLabel">
          <img style="width:16px" src="../../assets/image/icon_zhongd@2x.png" alt />
          <span>是否参与陪标</span>
        </div>
        <div class="rightInput">
          <div class="rightInput">
            <el-radio-group v-model="addFormData.is_mark" :disabled="!isSubmit">
              <el-radio :label="'1'">是</el-radio>
              <el-radio :label="'0'">否</el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>

      <div v-if="addFormData.is_mark == '1'">
        <div class="oneRow" style="margin-bottom:35px">
          <div class="leftLabel">
            <img style="width:16px" src="../../assets/image/icon_zy@2x.png" alt />
            <span>陪标信息</span>
          </div>
          <div class="rightInput">
            <el-button class="AddUser" v-if="isSubmit" @click="handleAddTM">添加信息</el-button>
          </div>
        </div>
        <div class="oneRow" style="margin-bottom:35px;padding-left:30px">
          <el-table
            :data="tableData"
            style="width:100%"
            border
            :header-cell-style="{ background: '#F4F5F6' }"
          >
            <el-table-column
              show-overflow-tooltip
              align="center"
              prop="name"
              label="公司名称"
              width="180"
            >
              <template slot-scope="scope">
                <span v-if="isSubmit" @click="tableClick(scope.row)">{{ scope.row.name }}</span>
                <span v-else>{{ scope.row.name }}</span>
              </template>
            </el-table-column>

            <el-table-column
              show-overflow-tooltip
              align="center"
              prop="money"
              label="陪标金额"
              width="180"
            >
              <template slot-scope="scope">
                <span v-if="isSubmit" @click="tableClick(scope.row)">{{ scope.row.money }}</span>
                <span v-else>{{ scope.row.money }}</span>
              </template>
            </el-table-column>

            <el-table-column show-overflow-tooltip align="center" prop="return_money" label="退回金额">
              <template slot-scope="scope">
                <span v-if="isSubmit" @click="tableClick(scope.row)">{{ scope.row.return_money }}</span>
                <span v-else>{{ scope.row.return_money }}</span>
              </template>
            </el-table-column>

            <el-table-column show-overflow-tooltip align="center" prop="address" label="操作">
              <template slot-scope="scope">
                <span
                  v-if="isSubmit"
                  style="cursor:pointer;color:#128BF1"
                  @click="removeUser(scope.$index, scope.row)"
                >删除</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <div class="oneRow" type="min-height:60px">
      <div class="leftLabel upLoadLabel">
        <img style="width:14px" src="../../assets/image/icon_fj@2x.png" alt />
        <span>上传附件</span>
      </div>
      <div class="rightInput">
        <upload-file
          :isSubmit="isSubmit"
          :imgList="this.addFormData.annex"
          :detailsImgList="detailsImgList"
          @my-upload-change="upLoadChange"
        ></upload-file>
      </div>
    </div>

    <div class="oneRow" style="margin-bottom:30px">
      <div class="leftLabel"></div>
      <div class="rightInput" style="display:flex;align-items:center">
        <div style="color:rgb(245, 95, 95);font-size:12px;">
          *请上传企业情况调查表（照片或文档），模板文件：
        </div>
        <a style="font-size:14px;" href="http://control.sxpz.vip/Template/企业情况调查表.doc">
          企业情况调查表.doc
        </a>
      </div>
    </div>

    <div class="oneRow textareaRow" style="margin-bottom:35px">
      <div class="leftLabel">
        <img style="width:17px" src="../../assets/image/icom_jj@2x.png" alt />
        <span>添加备注</span>
      </div>
      <div class="rightInput">
        <el-input
          v-model="addFormData.remark"
          :autosize="{ minRows: 3 }"
          :disabled="!isSubmit"
          type="textarea"
        ></el-input>
      </div>
    </div>

    <div
      class="oneRow"
      style="margin-bottom:35px;margin-top:20px"
      v-if="addFormData.is_approval == 1"
    >
      <div class="leftLabel">
        <img style="width:17px" src="../../assets/image/icom_jj@2x.png" alt />
        <span>审批备注</span>
      </div>
      <div class="rightInput">
        <el-input v-model="approval_remark"></el-input>
      </div>
    </div>

    <div class="btnRow">
      <el-button v-if="addFormData.is_edit != '1'" @click="handleSubmit('1')">保存草稿</el-button>
      <el-button
        v-if="addFormData.withdraw_status == '1'"
        style="background-color:rgb(255, 26, 26)"
        @click="handleProjectWithDraw"
      >撤回</el-button>
      <el-button
        v-if="addFormData.is_edit != '1' || addFormData.is_finance_edit == '1'"
        style="background-color:#40A0F2"
        :disabled="disableLimit"
        @click="handleSubmit('0')"
      >提交</el-button>
      <el-button
        v-if="addFormData.is_approval == 1"
        style="background-color:#f4a029"
        @click="handleExamine('-1')"
      >驳回</el-button>
      <el-button
        v-if="addFormData.is_approval == 1"
        style="background-color:#40A0F2"
        @click="handleExamine('1')"
      >审批通过</el-button>
    </div>

    <project-flow
      v-if="this.addFormData.approval_log && this.addFormData.approval_log.length > 0"
      :projectFlowLog="this.addFormData.approval_log"
      :projectName="this.addFormData.project_name"
      :companyName="this.addFormData.company_name"
      :projectId="this.addFormData.project_id"
      :stageCode="'11'"
    ></project-flow>
    <go-finance
      v-if="this.addFormData.approval_log && this.addFormData.approval_log.length > 0"
      :projectId="this.addFormData.project_id"
    ></go-finance>

    <el-dialog
      :visible.sync="dialogVisible"
      width="60%"
      :before-close="handleClose"
      :class="'addClientDia' "
      @close="handleClosed"
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <span class="title-age">名称检测</span>
      </div>
      <div style="min-height:60vh">
        <el-table
          v-if="this.nameCheckList.length > 0"
          :border="true"
          :data="nameCheckList"
          @row-click="tableRowClick"
        >
          <el-table-column align="center" label="企业全称">
            <template slot-scope="scope">
              <span class="tableNameCurrent">{{ scope.row.company_name }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="pte_show" align="center" label="类型展示"></el-table-column>
        </el-table>
        <div v-else style="text-align:center;">没有相似企业名称</div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="dialogVisibleAdd"
      width="50%"
      class="addUserDia"
      :before-close="handleCloseAdd"
      @close="handleClosedAdd"
    >
      <div slot="title" class="header-title">
        <span class="title-age">添加信息</span>
      </div>
      <div class="diaContainer">
        <el-form ref="form" :model="AddUserForm" label-width="30%">
          <el-form-item label="公司名称">
            <el-input :placeholder="isSubmit ? '公司名称' : ''" v-model="AddUserForm.name"></el-input>
          </el-form-item>
          <el-form-item label="陪标金额">
            <el-input
              v-model="AddUserForm.money"
              type="number"
              :placeholder="isSubmit ? '陪标金额' : ''"
            ></el-input>
          </el-form-item>
          <el-form-item label="退回金额">
            <el-input
              v-model="AddUserForm.return_money"
              type="number"
              :placeholder="isSubmit ? '退回金额' : ''"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button style="background-color:#ccc" @click="dialogVisibleAdd = false">取消</el-button>
        <el-button type="primary" v-if="diaFormType == 'add'" @click="handleAddUser">添加</el-button>
        <el-button type="primary" v-if="diaFormType == 'edit'" @click="editUserForm">修改</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
import ProjectFlow from '../ProjectFlow'
import GoFinance from '../GoFinance'
import OneSelected from '../OneSelected'
import SelectTransfer from '../selectTransfer'
import EvaluationTypeSelect from './EvaluationTypeSelect'
import UploadFile from '../UploadFile'
import PrintDialog from '../printTable/PrintDialog'
const createDefaultAddFormData = () => ({
  demand_type: '1',
  is_edit: '',
  is_approval: '',
  company_name: '',
  project_detail_name: '',
  project_full_name: '',
  project_type_id: '',
  permit_type: '1',
  permit_type_sub: '',
  department_id: '',
  inside_salesman: '',
  external_salesman: '',
  related_personnel: '',
  contacts: '',
  contact_number: '',
  annex: '',
  remark: '',
  leader: '',
  pte_id: '',
  pte_else: '',
  is_reg: '1',
  is_bid: '0',
  bid_money: 0,
  is_mark: '0',
  mark_json: '',
})

const normalizeRelatedPersonnelIds = (value) => {
  if (Array.isArray(value)) {
    return value
      .map((item) => {
        if (item && typeof item === 'object') {
          return item.id || item.member_id || item.value || ''
        }
        return item
      })
      .map((item) => String(item))
      .filter(Boolean)
  }
  if (value === null || value === undefined || value === '') {
    return []
  }
  return String(value)
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean)
}

// 评价类型：接收"英文逗号隔开的 id 字符串"，统一转成 id 数组
const normalizePteIds = (value) => {
  const list = Array.isArray(value)
    ? value.map((item) => {
        if (item && typeof item === 'object') {
          return item.id || item.pte_id || item.value || ''
        }
        return item
      })
    : value === null || value === undefined || value === ''
    ? []
    : String(value).split(',')
  return Array.from(
    new Set(list.map((item) => String(item).trim()).filter(Boolean))
  )
}
export default {
  data() {
    return {
      disableLimit: false,
      vccode: '1',
      abc: 'dingbudaohang',
      dialogVisible: false,
      tiemID: null,
      timeDou: 100,
      approval_remark: '',
      isSubmit: true,
      infop: '',
      member_id: '',
      company_id: '',
      cache_department_id: '',
      token: '',
      details_project_status: '',
      details_project_id: '',
      projectTypeList: [],
      detailsImgList: [],
      submitImgList: [],
      addFormData: createDefaultAddFormData(),
      relatedPersonnelIds: [],
      // 评价类型已选中的 id 数组（提交/接收均为英文逗号隔开的 id 字符串）
      pteTypeIds: [],
      projectDetails: {},
      classList: [],
      projectPjList: [],
      isComponentsShow: false,
      nameCheckList: [],
      // !陪标信息相关
      editTableIndex: '',
      tableData: [],
      diaFormType: 'add',
      dialogVisibleAdd: false,
      AddUserForm: { name: '', money: '', return_money: '' },

      // 项目列表
      projectList:[],
      project_id:'',
      project_years:'',
      baojia_name:''
    }
  },

  methods: {
   // 选择年份
   yearChange(val){
   if(!val){return}
    this.project_years = val
     console.log('选择年份',this.project_years)
   },
   async fetchBusinessDepartmentList(useCacheDepartment = true) {
    let params = new URLSearchParams()
      params.append('member_id', this.member_id)
      params.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        params.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        params.append('device', 'pc')
      }
      params.append('company_id', this.company_id)
      if (useCacheDepartment && this.cache_department_id) {
        params.append('cache_department_id', this.cache_department_id)
      }
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/is_business_department',
        data: params,
      })
      if (res.code != 200) {
        this.$message.error(res.datas.msg)
        return []
      }
      const listInfo = (res.datas && res.datas.listInfo) || []
      if (listInfo.length == 0 && useCacheDepartment && this.cache_department_id) {
        return this.fetchBusinessDepartmentList(false)
      }
      return listInfo
   },
       // 选择项目名称1
    async handleProjectSelectChange1(val) {
     console.log('val',val)
     
      if (val && val.length > 1) {
        // this.$message.error('关联项目只能选择1个')
        this.project_id = [val[0]]
      }
      // 强制刷新组件
      this.$forceUpdate()
    },
   // 搜索项目列表
async searchProjectList(val){
 if(!val)return
   let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)
      param.append('type','1')
      param.append('search', val)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/simple_project',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.projectList = res.datas.listInfo
      console.log('项目列表', this.projectList)
},
// 获取项目列表
async getProjectList(){
   let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)
      param.append('type','1')
    
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/simple_project',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.projectList = res.datas.listInfo
      console.log('项目列表', this.projectList)
},

    tableRowClick(row, column, event) {
      console.log()
      let routeUrl = this.$router.resolve({
        path: '/project/details/task',
        query: {
          project_id: row.project_id,
          project_name: row.company_name,
          isEdit: '1',
          formFinance: '1',
          project_status: '',
        },
      })
      window.open(routeUrl.href)
    },
    // 跳转合同登记
    goContract() {
      this.$router.push({
        path: '/financeTop',
        query: {
          project_id: this.addFormData.project_id,
          isFromProject: '1',
        },
      })
    },
    // !陪标信息相关
    handleAddTM() {
      this.diaFormType = 'add'
      this.dialogVisibleAdd = true
    },
    tableClick(row, column, event) {
      this.diaFormType = 'edit'
      this.editTableIndex = this.tableData.findIndex(
        (item) => item.id == row.id
      )
      this.AddUserForm = row
      console.log('this.AddUserForm', this.AddUserForm)
      console.log('clicked row', this.AddUserForm)
      this.dialogVisibleAdd = true
    },
    editUserForm() {
      this.tableData[this.editTableIndex] = this.AddUserForm
      // 提交修改的那个
      console.log('提交修改this.AddUserForm', this.AddUserForm)
      this.dialogVisibleAdd = false
    },
    // 添加成员
    handleAddUser() {
      this.tableData.push({
        id: new Date().getTime(),
        name: this.AddUserForm.name,
        money: this.AddUserForm.money,
        return_money: this.AddUserForm.return_money,
      })
      this.dialogVisibleAdd = false
    },
    // 删除成员
    removeUser(index, row) {
      this.tableData.splice(index, 1)
      console.log(this.tableData)
    },
    // !陪标信息相关
    // 选择评价类型（多选，is_department=0 的节点可勾选）
    handlePteTypeChange(ids) {
      this.pteTypeIds = normalizePteIds(ids)
      this.addFormData.pte_id = this.pteTypeIds.join(',')
    },
    handleRelatedPersonnelChange(data) {
      const selectedList = Array.isArray(data) ? data : []
      this.relatedPersonnelIds = selectedList
        .map((item) => item.id)
        .filter(Boolean)
        .map((item) => String(item))
      this.addFormData.related_personnel = this.relatedPersonnelIds.join(',')
    },
    // 点击新窗口打开项目页面
    goProjectDetailsOpenNew(items) {
      console.log('items', items)
      // this.$router.resolve({
      //   path: '/project/details/task',
      //   query: {
      //     project_id: items.project_id,
      //     project_name: items.project_name,
      //     isEdit: '1',
      //   },
      // })
      let routeUrl = this.$router.resolve({
        path: '/project/details/task',
        query: {
          project_id: items.project_id,
          project_name: items.project_name,
          isEdit: '1',
          formFinance: '1',
          project_status: '',
        },
      })
      window.open(routeUrl.href)
    },
    // 失去焦点校验名称
    async handleCheckName() {
      if (this.addFormData.company_name) {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)

        param.append('company_name', this.addFormData.company_name)

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/project_name_check',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        if (res.datas.listInfo && res.datas.listInfo.length > 0) {
          this.nameCheckList = res.datas.listInfo
          this.dialogVisible = true
        }
        // this.dialogVisible = true
      }
    },
    // *撤回项目
    async handleProjectWithDraw() {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)

        param.append('project_id', this.details_project_id)

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/withdraw',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getProjectDetails()
      }, this.timeDou)
    },
    selectPermitChange() {
      if (this.addFormData.permit_type == '1') {
        this.addFormData.permit_type_sub = ''
      }
      if (this.addFormData.permit_type == '2') {
        this.addFormData.permit_type_sub = '1'
      }
    },
    // *项目全称 = 公司名称 + 项目名称（自动拼接）
    updateCompanyName() {
      const fullName = this.addFormData.project_full_name || ''
      const projectName = this.addFormData.project_detail_name || ''
      this.addFormData.company_name = fullName + projectName
    },
    // *立项-项目登记审批
    async handleExamine(val) {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('project_id', this.details_project_id)

        param.append('approval_status', val)
        param.append('remark', this.approval_remark)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/project_reg_approval',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        // this.$router.push('/project/index')
        this.getProjectDetails()
      }, this.timeDou)
    },
    // *立项-项目登记-获取项目详情(当有projectid时)
    async getProjectDetails() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('project_id', this.details_project_id)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/project_reg_detail',
        data: param,
      })
      this.addFormData = {
        ...createDefaultAddFormData(),
        ...res.datas.info,
      }
      // *项目全称随公司名称/项目名称自动拼接
      this.updateCompanyName()
      if(this.addFormData.project_years){
        this.project_years = this.addFormData.project_years
      }
      if (this.addFormData.is_draft != '1' && this.addFormData.is_edit == '1') {
        this.isSubmit = false
      } else {
        this.isSubmit = true
      }
      if (this.addFormData.annex) {
        this.detailsImgList = this.addFormData.annex
        this.submitImgList = this.addFormData.annex
      }
      // 处理内部业务人员
      if (this.addFormData.inside_salesman_id == '0') {
        this.addFormData.inside_salesman_id = ''
      }
      // 判断表格
      if (this.addFormData.mark_json) {
        this.tableData = JSON.parse(this.addFormData.mark_json)
        this.tableData.forEach((item) => {
          if (!item.id)
            item.id = parseInt((Math.random() + 1) * Math.pow(10, 6 - 1))
        })
      }
      // 评价类型（接口返回的是英文逗号隔开的 id 字符串，拆分后交给多选组件回显）
      this.pteTypeIds = normalizePteIds(this.addFormData.pte_id)
      this.addFormData.pte_id = this.pteTypeIds.join(',')
      this.relatedPersonnelIds = normalizeRelatedPersonnelIds(
        this.addFormData.related_personnel
      )
      this.addFormData.related_personnel = this.relatedPersonnelIds.join(',')
      // 版本号
      if (this.addFormData.version_code) {
        this.vccode = this.addFormData.version_code
      }

      console.log('项目登记详情', this.addFormData)
      this.$store.commit('process/projectTable/setPrintData', this.addFormData)
      console.log('#$%^&项目登记详情', this.addFormData.is_reg)
      this.isComponentsShow = true
      console.log('qwesdfsdfbsthis.tableData', this.tableData)
      // if (res.code != 200) return this.$message.error(res.datas.msg)
    },
    // *立项-项目登记-提交
    async handleSubmit(val) {
     // 项目年份点击取消后让其为空
     if(this.project_years=='null'||this.project_years==null){
      this.project_years = ''
     }

      // 编辑
      if (this.details_project_id) {
        this.disableLimit = true
        if (!this.addFormData.external_salesman) {
          this.addFormData.external_salesman = ''
        }
        if (!this.addFormData.inside_salesman_id) {
          this.addFormData.inside_salesman_id = ''
        }
        this.addFormData.related_personnel = this.relatedPersonnelIds.join(',')
        this.addFormData.mark_json = JSON.stringify(this.tableData)
        clearTimeout(this.tiemID)
        this.tiemID = setTimeout(async () => {
          let param = new URLSearchParams()
          param.append('member_id', this.member_id)
          param.append('token', this.token)
          if (this.$store.state.process.app.deviceInfo) {
            param.append('device', this.$store.state.process.app.deviceInfo)
          } else {
            param.append('device', 'pc')
          }
          param.append('cache_department_id', this.cache_department_id)
          param.append('company_id', this.company_id)
          param.append('project_id', this.details_project_id)

          // 仅申请项目编号
          param.append('demand_type', this.addFormData.demand_type)

          param.append('is_draft', val)
          param.append('company_name', this.addFormData.company_name)
          param.append('project_detail_name', this.addFormData.project_detail_name)
          param.append('project_full_name', this.addFormData.project_full_name)
          param.append('project_type_id', this.addFormData.project_type_id)
          param.append('permit_type', this.addFormData.permit_type)
          param.append('permit_type_sub', this.addFormData.permit_type_sub)
          param.append('department_id', this.addFormData.department_id)
          param.append('inside_salesman', this.addFormData.inside_salesman_id)
          param.append('external_salesman', this.addFormData.external_salesman)
          param.append('related_personnel', this.addFormData.related_personnel)
          param.append('contacts', this.addFormData.contacts)
          param.append('contact_number', this.addFormData.contact_number)
          param.append('annex', JSON.stringify(this.submitImgList))
          param.append('remark', this.addFormData.remark)
          // 评价类型（多选，英文逗号隔开的 id 字符串）
          param.append('pte_id', this.addFormData.pte_id)

          param.append('pte_else', this.addFormData.pte_else)

          param.append('is_bid', this.addFormData.is_bid)
          param.append('bid_money', this.addFormData.bid_money)
          param.append('is_mark', this.addFormData.is_mark)
          param.append('mark_json', this.addFormData.mark_json)
          param.append('project_years', this.project_years)
          const { data: res } = await this.$axios({
            method: 'post',
            url: '/api/Project/project_reg_edit',
            data: param,
          })
          if (res.code != 200) {
            // 提交校验失败：保留用户已填内容，仅恢复按钮并提示错误
            // （原逻辑会重置 addFormData / relatedPersonnelIds / pteTypeIds，导致已填内容清空）
            this.disableLimit = false
            this.$message.error(res.datas.msg)
            return
          }
          this.$message.success(res.datas.msg)
          this.disableLimit = false
          // this.$router.push('/project/index')
          this.getProjectDetails()
        }, this.timeDou)
      } else {
        // return console.log('abc', this.abc)
        // 新增
        this.disableLimit = true
        if (!this.addFormData.external_salesman) {
          this.addFormData.external_salesman = ''
        }
        if (!this.addFormData.inside_salesman_id) {
          this.addFormData.inside_salesman_id = ''
        }
        this.addFormData.related_personnel = this.relatedPersonnelIds.join(',')
        this.addFormData.mark_json = JSON.stringify(this.tableData)
        clearTimeout(this.tiemID)
        this.tiemID = setTimeout(async () => {
          let param = new URLSearchParams()
          param.append('member_id', this.member_id)
          param.append('token', this.token)
          if (this.$store.state.process.app.deviceInfo) {
            param.append('device', this.$store.state.process.app.deviceInfo)
          } else {
            param.append('device', 'pc')
          }
          param.append('cache_department_id', this.cache_department_id)
          param.append('company_id', this.company_id)

          // 仅申请项目编号
          param.append('demand_type', this.addFormData.demand_type)

          param.append('is_draft', val)
          param.append('company_name', this.addFormData.company_name)
          param.append('project_detail_name', this.addFormData.project_detail_name)
          param.append('project_full_name', this.addFormData.project_full_name)
          param.append('project_type_id', this.addFormData.project_type_id)
          param.append('permit_type', this.addFormData.permit_type)
          param.append('permit_type_sub', this.addFormData.permit_type_sub)
          param.append('department_id', this.addFormData.department_id)
          param.append('inside_salesman', this.addFormData.inside_salesman_id)
          param.append('external_salesman', this.addFormData.external_salesman)
          param.append('related_personnel', this.addFormData.related_personnel)
          param.append('contacts', this.addFormData.contacts)
          param.append('contact_number', this.addFormData.contact_number)
          param.append('annex', JSON.stringify(this.submitImgList))
          param.append('remark', this.addFormData.remark)
          // 评价类型（多选，英文逗号隔开的 id 字符串）
          param.append('pte_id', this.addFormData.pte_id)
          param.append('pte_else', this.addFormData.pte_else)

          param.append('is_bid', this.addFormData.is_bid)
          param.append('bid_money', this.addFormData.bid_money)
          param.append('is_mark', this.addFormData.is_mark)
          param.append('mark_json', this.addFormData.mark_json)
          param.append('project_years', this.project_years)
          const { data: res } = await this.$axios({
            method: 'post',
            url: '/api/Project/project_reg',
            data: param,
          })
          if (res.code != 200) {
            this.disableLimit = false
            return this.$message.error(res.datas.msg)
          }
          this.$message.success(res.datas.msg)
          this.disableLimit = false
          this.$router.push('/project/index')
        }, this.timeDou)
      }
    },
    // 评价类型改变方法
    handleOtherIs() {
      // 多选后 pte_id 是英文逗号隔开的 id 字符串，判断是否勾选了"其他"（-1）
      if (!this.pteTypeIds.includes('-1')) {
        this.addFormData.pte_else = ''
      }
    },
    upLoadChange(data) {
      console.log('文件列表', data)
      this.submitImgList = data
    },
    transferChange(data) {
      this.addFormData.inside_salesman_id = data
      console.log('inside salesman changed', data)
    },
    // 获取项目类型
    async getProjectTypeList() {},
    handleClose() {
      this.dialogVisible = false
    },
    handleClosed() {},
    handleCloseAdd() {
      this.dialogVisibleAdd = false
    },
    handleClosedAdd() {
      this.AddUserForm = { name: '', money: '', return_money: '' }
      this.diaFormType = 'add'
      this.editTableIndex = ''
    },
  },
  watch: {
    'addFormData.is_bid': {
      handler: function (val, oldVal) {
        if (val == '0') {
          this.addFormData.bid_money = 0
        }
      },
    },
    'addFormData.is_mark': {
      handler: function (val, oldVal) {
        if (val == '0') {
          this.tableData = []
        }
      },
    },
    // *公司名称变化时，自动更新项目全称
    'addFormData.project_full_name': {
      handler: function () {
        this.updateCompanyName()
      },
    },
    // *项目名称变化时，自动更新项目全称
    'addFormData.project_detail_name': {
      handler: function () {
        this.updateCompanyName()
      },
    },
  },
  mounted() {},
  async created() {
    if (this.$route.query.type == 'addPage') {
      this.isComponentsShow = true
    }
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
    // this.getProjectTypeList()
    this.details_project_id = this.$route.query.project_id || ''
    this.details_project_status = this.$route.query.project_status || ''
    // 获取项目类型
    let param = new URLSearchParams()
    param.append('member_id', this.member_id)
    param.append('token', this.token)
    if (this.$store.state.process.app.deviceInfo) {
      param.append('device', this.$store.state.process.app.deviceInfo)
    } else {
      param.append('device', 'pc')
    }
    param.append('cache_department_id', this.cache_department_id)
    param.append('company_id', this.company_id)
    this.$axios({
      method: 'post',
      url: '/api/Project/project_type',
      data: param,
    }).then((res) => {
      if (res.data.code != 200) return this.$message.error(res.datas.msg)
      this.projectTypeList = res.data.datas.listInfo
      if (this.projectTypeList.length == 0) {
        this.$message.error('请先在管理-项目设置-内设置项目类型')
      }
      if (this.projectTypeList.length > 0)
        this.addFormData.project_type_id =
          this.projectTypeList[0].project_type_id
      console.log('项目类型列表', this.projectTypeList)
      // **获取部门列表
      this.fetchBusinessDepartmentList().then((listInfo) => {
        this.classList = listInfo
        if (this.classList.length > 0) {
          const currentDepartmentExists = this.classList.some(
            (item) => item.department_id == this.addFormData.department_id
          )
          if (!currentDepartmentExists) {
            this.addFormData.department_id = this.classList[0].department_id
          }
        } else {
          this.$message.warning('当前账号未获取到负责部门，请检查部门权限配置')
        }
        console.log('部门列表', this.classList)
        // **获取评价类型列表
        let paramss = new URLSearchParams()
        paramss.append('member_id', this.member_id)
        paramss.append('token', this.token)
        paramss.append('company_id', this.company_id)
        paramss.append('cache_department_id', this.cache_department_id)
        this.$axios({
          method: 'post',
          // url: '/api/Project/evaluation_type',
          url: '/api/Management/pte_list',
          data: paramss,
        }).then((resss) => {
          if (resss.data.code != 200) return this.$message.error(ress.datas.msg)
          this.projectPjList = resss.data.datas.listInfo
          console.log('评价类型列表', this.projectPjList)

          if (this.projectPjList.length > 0)
            if (this.details_project_status && this.details_project_id) {
              // this.addFormData.pte_id = this.projectPjList[0].pte_id
              // 获取项目详情

              this.getProjectDetails()
            }
        })
      })
    })
    // 获取项目类型

    // 获取项目列表
    this.getProjectList()
  },
  computed: {
    isTypeInputDis() {
      // 多选后 pte_id 是英文逗号隔开的 id 字符串，只要勾选了"其他"（-1）就允许填写
      return !this.pteTypeIds.includes('-1')
    },
  },
  components: {
    OneSelected,
    SelectTransfer,
    EvaluationTypeSelect,
    UploadFile,
    ProjectFlow,
    GoFinance,
    PrintDialog,
  },
}
</script>
<style lang="less" scoped>
@import url(./projectForm.less);
/deep/ .oneRow .el-radio-group .el-radio {
  width: auto !important;
  margin-right: 20px !important;
}
.tableNameCurrent {
  cursor: pointer;
}
.tableNameCurrent:hover {
  color: #128bf1;
}
.pointisNotSubmitSpan {
  color: -webkit-link;
  cursor: pointer;
}
.pointisNotSubmitSpan:hover {
  // color: #032844;
}
.btnPosition {
  position: absolute;
  width: 120px;
  height: 120px;
  right: 10px;
  background-color: red;
}
.relatedPersonnelLabel {
  width: 220px !important;
}
/deep/ .relatedPersonnelLabel span {
  white-space: nowrap;
}
/deep/ .relatedPersonnelLabel + .rightInput {
  width: calc(100% - 220px) !important;
}
</style>
